var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../appContext";
import { MessageByTypeEnum, MessageFormatType, } from "../Models";
import { getSystemMessage } from "../Utils";
import TypingLoader from "./TypingLoader";
import TimeAgo from "../Timeago";
import { DEFAULT_BOT_ICON } from "../globals";
var ConversationListItem = function (props) {
    var _a, _b, _c, _d, _e;
    var parentContext = useContext(AppContext);
    var setSessions = parentContext.setSessions;
    var sessions = parentContext.sessions;
    var from = MessageByTypeEnum[(_a = props.session.message_list[props.session.message_list.length - 1]) === null || _a === void 0 ? void 0 : _a.from];
    var _f = useState(null), agentTypingTimer = _f[0], setAgentTypingTimer = _f[1];
    // useEffect(() => {
    //   setTimeout(function () {
    //     if (!props.session) return;
    //     // console.log(that.session.id, that.session.typing);
    //     props.session.typing = false;
    //     props.updateSession();
    //   }, 3000);
    // }, [props.session.typing_alert])
    var getLatestChat = function () {
        try {
            // if (props.session.type == "BOT") {
            return props.session.message_list[props.session.message_list.length - 1];
            //}
            // return this.session.message_list[this.session.message_list.length - 1];
        }
        catch (error) {
            return undefined;
        }
    };
    var getLatestMessage = function () {
        try {
            var mssg = getLatestChat();
            if (mssg && mssg.system_message_type == MessageFormatType.FLOW_NODE && mssg.meta_data) {
                var execution = JSON.parse(mssg.meta_data).executionNode;
                var type = execution.node.type !== "ACTION"
                    ? execution.node.type
                    : execution.node.data.nodeType;
                switch (type) {
                    case "START":
                        return execution.node.data.formData.start_message;
                        break;
                    case "MULTIPLE_CHOICE":
                        return JSON.parse(execution.responseAction[0].data).displayText;
                        break;
                    case "AUTOMATED_ANSWER":
                        return execution.node.data.formData.message;
                        break;
                    case "COLLECT_FORM_DATA":
                        return 'Form Data';
                        break;
                    case "COLLECT_TEXT_REPLY":
                        return execution.responseAction[0].data;
                        break;
                    default:
                        break;
                }
            }
            if (mssg &&
                mssg.from === "System" &&
                (!mssg.message || mssg.system_message_type === "CHAT_SESSION_CLOSED"))
                return (mssg.system_message_type && getSystemMessage(mssg.system_message_type));
            return mssg === null || mssg === void 0 ? void 0 : mssg.message;
        }
        catch (error) { }
    };
    // const clickOpenBotConversation = () => {
    //   props.openBotConversation(props.session.conversationId)
    // }
    var clickOpenChatConversation = function () {
        props.session.unRead = 0;
        props.openChatConversation(props.session.id + "");
    };
    var getMessageTime = function () {
        try {
            if (!props.session.message_list || props.session.message_list.length == 0)
                return 0;
            return (props.session.message_list[props.session.message_list.length - 1]
                .created_time * 1000);
        }
        catch (e) {
            console.log("Issue getMessageTime", e);
            return new Date().getTime();
        }
    };
    var getImage = function () {
        var _a, _b;
        if (props.session && props.session.id && props.session.connected_with == "GPT") {
            return DEFAULT_BOT_ICON;
        }
        var lastMessage = getLatestChat();
        if (!lastMessage)
            return parentContext.chatPrefs.widget.default_profile_image;
        if (lastMessage.system_message_type == MessageFormatType.FLOW_NODE)
            return "https://d2p078bqz5urf7.cloudfront.net/cloud/assets/img/chatbot-default-icon.png";
        if (lastMessage.from == MessageByTypeEnum.Agent) {
            var agent = (_a = parentContext.agents) === null || _a === void 0 ? void 0 : _a.find(function (agent) {
                return agent.id === lastMessage.user_id;
            });
            return agent && agent.profile_img_url
                ? agent.profile_img_url
                : parentContext.chatPrefs.widget.default_profile_image;
        }
        else if (lastMessage.from == MessageByTypeEnum.GPT) {
            var bot = (_b = parentContext.chatPrefs.botPrefs) === null || _b === void 0 ? void 0 : _b.find(function (bot) {
                return bot.id === lastMessage.gpt_bot_id;
            });
            return bot && bot.settings.chatBotIconURL
                ? bot.settings.chatBotIconURL
                : parentContext.chatPrefs.widget.default_profile_image;
        }
        return parentContext.chatPrefs.widget.default_profile_image;
    };
    var getName = function () {
        var _a, _b;
        var lastMessage = getLatestChat();
        console.log(lastMessage, " lastMessage");
        if (!lastMessage)
            return "";
        if (lastMessage.from == MessageByTypeEnum.Agent) {
            var agent = (_a = parentContext.agents) === null || _a === void 0 ? void 0 : _a.find(function (agent) {
                return agent.id === lastMessage.user_id;
            });
            return agent && agent.name ? agent.name : "Agent";
        }
        else if (lastMessage.from == MessageByTypeEnum.GPT) {
            var bot = (_b = parentContext.chatPrefs.botPrefs) === null || _b === void 0 ? void 0 : _b.find(function (bot) {
                return bot.id === lastMessage.gpt_bot_id;
            });
            return bot && bot.name ? bot.name : "Bot";
        }
        else if (lastMessage.from == MessageByTypeEnum.System) {
            return "Operator";
        }
        return "You";
    };
    useEffect(function () {
        clearTimer();
        if (!props.session.typing)
            return;
        resetTimer();
    }, [props.session.typing]);
    useEffect(function () {
        clearTimer();
        resetTimer();
    }, [props.session.typing_alert]);
    var clearTimer = function () {
        if (agentTypingTimer)
            clearTimeout(agentTypingTimer);
        // console.log("clearTimer", this.agentTypingTimer);
        setAgentTypingTimer(null);
    };
    var resetTimer = function () {
        var typingTimer = setTimeout(function () {
            if (!props.session)
                return;
            props.session.typing = false;
            setSessions(__spreadArray([], sessions, true));
        }, 3000);
        setAgentTypingTimer(typingTimer);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "chat__all-messages-item", "data-trigger": "all", onClick: function () { return clickOpenChatConversation(); } }, { children: [_jsx("div", __assign({ className: "chat__all-messages-item-avatar" }, { children: _jsx("div", __assign({ className: "chat__all-messages-item-profile", style: { backgroundImage: 'url("' + getImage() + '")' } }, { children: "\u00A0" })) })), _jsxs("div", __assign({ className: "chat__all-messages-item-copy" }, { children: [_jsx("div", __assign({ className: "chat__all-messages-item-main" }, { children: props.session.typing ||
                                ((_b = getLatestChat()) === null || _b === void 0 ? void 0 : _b.message_type) === "FETCHING" ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ "data-a": JSON.stringify(getLatestChat()) }, { children: (_c = getLatestChat()) === null || _c === void 0 ? void 0 : _c.message })), _jsx(TypingLoader, {})] })) : (_jsxs(_Fragment, { children: [_jsx("p", __assign({ className: "".concat(props.session.unRead > 0 ? "unRead" : "") }, { children: ((_d = getLatestChat()) === null || _d === void 0 ? void 0 : _d.message_type) == "TEXT" ||
                                            from == MessageByTypeEnum.System ? (getLatestMessage()) : (_jsx(_Fragment, {})) })), _jsx("p", { children: ((_e = getLatestChat()) === null || _e === void 0 ? void 0 : _e.message_type) == "FILE" ? (_jsxs(_Fragment, { children: ["File", " ", from == MessageByTypeEnum.Visitor ? (_jsx("span", { children: "Sent" })) : (_jsx("span", { children: "Received" }))] })) : (_jsx(_Fragment, {})) })] })) })), _jsxs("div", __assign({ className: "chat__all-messages-item-header" }, { children: [_jsxs("p", __assign({ className: "chat-messages-username" }, { children: [" ", getName()] })), _jsxs("p", __assign({ className: "chat__all-messages-item-header-timegao" }, { children: ["\u2022", " ", _jsx(TimeAgo, { date: getMessageTime() })] }))] }))] })), _jsx("div", { children: props.session.unRead > 0 ? (_jsx("span", __assign({ className: "chat__all-btn chat_notifications_count" }, { children: props.session.unRead }))) : (_jsx(_Fragment, {})) }), _jsx("div", __assign({ className: "chat__all-messages-item-arrow" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, { children: _jsx("path", { d: "M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z", fill: "#000000" }) })) }))] })) }));
};
export default ConversationListItem;
